export const Lightbox = ({ src, onClose }) => {
  if (!src) return null;
  return (
    <div
      className="no-print fixed inset-0 z-50 bg-black/85 backdrop-blur-md flex items-center justify-center p-4 animate-fade-up"
      onMouseDown={onClose}
      data-testid="lightbox"
    >
      <div className="relative max-w-4xl max-h-[90vh]">
        <img
          src={src}
          alt="Foto Bukti"
          className="max-w-full max-h-[85vh] rounded-lg object-contain mx-auto shadow-2xl"
        />
        <button
          onClick={onClose}
          className="absolute top-2 right-2 bg-slate-900/80 text-white p-2 rounded-full hover:bg-slate-800 transition-colors"
          data-testid="lightbox-close-btn"
        >
          <i className="ph-bold ph-x text-xl" />
        </button>
      </div>
    </div>
  );
};
